module.exports = __webpack_public_path__ + "static/media/monthly-expense.1235536e.png";